import axios from "axios";
import { Dependencies } from "@planzone/core";
import { ProjectExternalLink } from "@planzone/dto";

function getLinkDocument({ url }: ProjectExternalLink) {
  return axios.get(`/external-links?url=${url}`);
}

function createIconExtractor(): Dependencies["iconExtractor"] {
  return {
    extractIcon(link) {
      const hasSeparator = link.url[link.url.length - 1] === "/";

      return getLinkDocument(link)
        .then(({ data }) => data.url)
        .catch(() => {
          try {
            const domain = new URL(link.url);
            return `${domain.protocol}//${domain.hostname}/favicon.ico`;
          } catch (e) {
            return `${link.url}${hasSeparator ? "" : "/"}favicon.ico`;
          }
        });
    },
  };
}

export { createIconExtractor };
